import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { throwApiError } from "../errorHandler";
import { UserPreferences } from "../../types/userPreferences";

/**
 * Fetch user preferences from Collins API.
 * Throws on failure so the caller can distinguish between
 * "the API returned data" and "the request failed".
 */
export const fetchUserPreferences = async (): Promise<UserPreferences> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const response = await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/users/me/preferences`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    }
  );

  if (!response.ok) {
    await throwApiError(response, "Error fetching user preferences");
  }

  return await response.json();
};
